import React from 'react';
import classNames from 'classnames';
import { Menu, MenuLabel, MenuContent, MenuItem, IconFlags } from '../../components';
import { languagesHelper as language } from '../../helpers/languages';
import config from '../../config';

import css from './MultiLanguageSelect.module.css';

const MultiLanguageSelect = () => {

  let currentLocale = language.get();

  const changeLanguage = (locale) => {
    if (currentLocale === locale) {
      return;
    }
    language.set(locale);
  };


  return (
    <Menu className={classNames(css.root)}>
      <MenuLabel className={css.languageButton}>
        <div className={css.languageOption}>
          <IconFlags flag={currentLocale} className={css.flagImg} />
          <span>{currentLocale}</span>
        </div>
      </MenuLabel>
      <MenuContent className={css.languagesOptions} useDefaultStyles={false}>
        <MenuItem key="LV">
          <div className={css.languageOption} onClick={() => changeLanguage('lv')}>
            <IconFlags flag="lv" className={css.flagImg} />
            <span>LV</span>
          </div>
        </MenuItem>
        <MenuItem key="EN">
          <div className={css.languageOption} onClick={() => changeLanguage('en')}>
            <IconFlags flag="en" className={css.flagImg} />
            <span>EN</span>
          </div>
        </MenuItem>
        {/* <MenuItem key="RU">
          <div className={css.languageOption} onClick={() => changeLanguage('ru')}>
            <IconFlags flag="ru" className={css.flagImg} />
            <span>RU</span>
          </div>
        </MenuItem>
        <MenuItem key="ET">
          <div className={css.languageOption} onClick={() => changeLanguage('et')}>
            <IconFlags flag="et" className={css.flagImg} />
            <span>ET</span>
          </div>
        </MenuItem>
        <MenuItem key="LT">
          <div className={css.languageOption} onClick={() => changeLanguage('lt')}>
            <IconFlags flag="lt" className={css.flagImg} />
            <span>LT</span>
          </div>
        </MenuItem> */}
      </MenuContent>
    </Menu>
  );
};

export default MultiLanguageSelect;
